(function ($) {
	"use strict";
	let blockWheelsCircularProgressBar = {
		initAll: function () {

			const elementList = document.querySelectorAll('.wp-block-blockwheels-circular-bar');

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Progress Bar
			[...elementList].forEach((circular) => {
				let circleId 	= $(circular).data('id'),
					number 		= $(circular).find('.blockwheels-circular-progressbar').data('number'),
					thickness 	= $(circular).find('.blockwheels-circular-progressbar').data('thickness'),
					label 		= $(circular).find('.blockwheels-circular-progressbar').data('label'),
					bgColor 	= $(circular).find('.blockwheels-circular-progressbar').data('background'),
					baseBgColor = $(circular).find('.blockwheels-circular-progressbar').data('base');

				let circleProgressBar = new ProgressBar.Circle('#circle-' + circleId, {
					color: bgColor,
					strokeWidth: thickness,
					trailWidth: thickness,
					easing: 'easeInOut',
					duration: 1400,
					trailColor: baseBgColor,
					text: {
						autoStyleContainer: false
					  },
					from: { color: bgColor, width: thickness},
					to: { color: baseBgColor, width: thickness},
					 // Set default step function for all animate calls
					step: function(state, circle) {
						let value = Math.round(circle.value() * 100);
						if (value === 0) {
							circle.setText('');
						} else {
							value = ( label !== undefined && label !== '' ) ? label + ' ' + value + '%' : value + '%';
							circle.setText( value );
						}
					}
				});
				circleProgressBar.set(0);
				let controller = new ScrollMagic.Controller();
				let desiredAnimation = new ScrollMagic.Scene({triggerElement: '#circle-' + circleId, duration: 200});
				desiredAnimation.addTo(controller);
				desiredAnimation.on("enter", function (e) {
					circleProgressBar.animate(number);  // Number from 0.0 to 1.0
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockWheelsCircularProgressBar.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockWheelsCircularProgressBar.init);
	} else {
		// The DOM has already been loaded.
		blockWheelsCircularProgressBar.init();
	}
})(jQuery);